import { Box, Typography } from '@mui/material';
import { FC } from 'react';

export const DpIARecommendationBadge: FC = () => (
	<Box
		className="badge-ia-header"
		sx={{
			display: 'inline-flex',
			justifyContent: 'center',
			alignItems: 'center',
			gap: { xs: '4px', sm: '6px' },
			padding: { xs: '4px 6px', sm: '6px 12px' },
			borderRadius: '999px',
			backgroundColor: 'rgba(83, 74, 183, 0.08)',
			border: '1px solid rgba(83, 74, 183, 0.25)',
			color: '#534AB7',
			lineHeight: 1,
		}}
	>
		<Box
			component="svg"
			viewBox="0 0 15 15"
			fill="none"
			sx={{ flexShrink: 0, width: '15px', height: '15px', alignSelf: 'center' }}
		>
			<path d="M8 1l1.5 4.5L14 7l-4.5 1.5L8 13l-1.5-4.5L2 7l4.5-1.5L8 1z" fill="#534AB7" />
		</Box>
		<Typography
			component="span"
			sx={{
				fontSize: { xs: '12px', sm: '14px' },
				fontWeight: 600,
				color: '#534AB7',
				lineHeight: 1,
			}}
		>
			Recomendado por IA
		</Typography>
	</Box>
);
